<template>
	<div v-click-outside="clickOutside" class="searcher">
		<input
			:size="this.size"
			:value="searchWord"
			type="search"
			placeholder="제품 검색"
			class="searcher__input"
			:disabled="this.disabled"
			@keyup.down.prevent="selectByArrow(0, true)"
			@input="onInput"
			@keypress.enter.prevent
			ref="input"
		/>
		<ul
			v-if="list.length"
			:class="[
				'searcher__result-list results',
				{ 'searcher__result-list--relative': !absoluteList },
			]"
		>
			<li v-for="(item, idx) in list" :key="item.idProduct" ref="results">
				<button
					v-html="item.name"
					type="button"
					class="results__item__select-button"
					@click="selecting(item)"
					@keydown.up.prevent="
						selectByArrow(idx === 0 ? 'input' : idx - 1)
					"
					@keydown.down.prevent="
						selectByArrow(idx + 1 === list.length ? idx : idx + 1)
					"
				/>
			</li>
		</ul>
	</div>
</template>
<script>
	import compact from 'lodash/compact';
	import debounce from 'lodash/debounce';
	import { useObservers } from '@/util';
	import ClickOutside from 'vue-click-outside';

	export default {
		name: 'ProductSearcher2',
		directives: {
			ClickOutside,
		},
		props: {
			size: { type: String, default: '0' },
			mode: { type: String, default: null },
			idProduct: { type: Number, default: null },
			disabled: { type: Boolean, default: false },
			absoluteList: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				searchWord: '',
				disconnect: null,
				list: [],
				offset: 0,
				limit: 100,
				maxOffset: 0,
				intersection: useObservers().intersection,
			};
		},
		async created() {
			if (this.idProduct) {
				await this.selectById(this.idProduct);
			}
		},
		beforeDestroy() {
			if (this.disconnect) {
				this.disconnect();
			}
		},
		methods: {
			init() {
				this.searchWord = '';
			},
			clickOutside() {
				this.list = [];
			},
			setObserver(listElem = []) {
				if (this.maxOffset > this.offset && listElem.length) {
					const lastIdx = listElem.length - 1;
					this.disconnect = this.intersection(
						listElem[lastIdx],
						() => {
							this.getList();
						}
					);
				}
			},
			async reqApi(params) {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/api/products',
						{ params }
					);
					return {
						...data,
						data: data.data.map(item => ({
							...item,
							name:
								compact([
									`[${item.idProduct}][${item.brandTitle}]`,
									item.isDisplay
										? ''
										: '<b class="font-red">[비전시]</b>',
									item.isDiscontinue
										? '<b class="font-red">[단종]</b>'
										: '',
								]).join('') +
								' ' +
								item.productTitle,
						})),
					};
				} catch (err) {
					console.error(
						'제품검색에 오류가 발생했습니다. 개발팀에 문의하세요.'
					);
					console.error(err);
				}
			},
			async getList() {
				const params = {
					offset: this.offset,
					limit: this.limit,
				};
				const searchWord = this.searchWord;
				if (/^\d+$/.test(searchWord)) {
					params.idProduct = searchWord;
				} else {
					params.searchWord = searchWord;
				}
				const data = await this.reqApi(params);
				this.list = [...this.list, ...data.data];
				this.maxOffset = data.limit * data.pageTotal;
				this.offset += this.limit;
				await this.$nextTick();
				this.setObserver(this.$refs.results);
			},
			onInput: debounce(function ({ target }) {
				this.searchWord = target.value;
				this.offset = 0;
				this.list = [];
				if (this.searchWord) {
					this.getList();
				} else {
					this.$emit('change', null);
				}
			}, 300),
			selecting(item) {
				this.list = [];
				this.searchWord = '';
				if (this.mode == 'search_view') {
					this.searchWord = this.getProductLabel(item);
				}
				this.$emit('change', item);
			},
			async selectById(idProduct) {
				const params = {
					offset: 0,
					limit: 1,
					idProduct,
				};
				const { data } = await this.reqApi(params);
				this.selecting(data[0]);
			},
			getProductLabel(item) {
				return (
					[
						`[${item.idProduct}][${item.brandTitle}]`,
						item.isDisplay ? '' : '[비전시]',
						item.isDiscontinue ? '[단종]' : '',
					].join('') +
					' ' +
					item.productTitle
				);
			},
			selectByArrow(idx, fromInput) {
				const selectorList = this.$refs.results;
				if (fromInput) {
					this.$refs.input.focus();

					setTimeout(() => {
						selectorList[idx]
							.querySelector('.results__item__select-button')
							.focus();
					}, 700);
					return;
				}
				if (!selectorList || idx === 'input') {
					this.$refs.input.focus();

					return;
				}
				selectorList[idx]
					.querySelector('.results__item__select-button')
					.focus();
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.searcher {
		position: relative;
		width: 100%;

		.searcher__input {
			border-radius: 0;

			&:focus {
				border-color: lightblue;
			}

			&:focus + .results {
				border-color: lightblue;
			}
		}

		.results {
			z-index: 100;
			overflow-y: auto;
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			max-height: 486px;
			margin-top: -1px;
			border: solid 1px #dfe6ee;
			background-color: #fff;
		}

		.searcher__result-list--relative {
			position: relative;
			top: 0;
		}

		.results__item__select-button {
			overflow: hidden;
			display: block;
			width: 100%;
			height: 36px;
			color: #222;
			font-size: 0.875rem;
			text-align: left;
			padding: 0 12px;
			text-align: left;
			text-overflow: ellipsis;

			&:hover,
			&:focus {
				font-weight: bold;
				padding: 0 11px;
				background-color: #ecf2f8;
			}
		}
	}
</style>
